import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ConfirmedValidator } from 'src/app/confirmed.validator';
import { ApiService } from '../../services/api.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { UserService } from 'src/app/services/user.service';
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
    public loader = false;
    id: string;
    isSetPassword :any;
    email: any;
    isBtnDisabled = true;
    lblforgotpasswordstatus: any;
    form: FormGroup;
    constructor(
        private fb: FormBuilder,
        private userService: UserService,
        public api: ApiService,
        private route: ActivatedRoute,
        public router: Router,
    ) {
        this.form = this.fb.group({
            newPassword: ['', [Validators.required]],
            confirmPassword: ['', [Validators.required]]
        }, { 

          validator: ConfirmedValidator('newPassword', 'confirmPassword')

        })
    }

    ngOnInit() {
        this.route.queryParams
          .subscribe(params => {
            this.id = params.id;
            this.isSetPassword = params.setPassword || false;
          }
        );

        this.getStatus();
    }

    getStatus() {
        const obj: any = {};
        obj.id = this.id;
        this.api.getData(this.api.apiUrl.scoutResetStatus, obj, true)
      .subscribe(res => {
        console.log('res', res);
        if(res.statusCode == 200)
        {
          
            this.isBtnDisabled = false;
        }
        else{
          this.router.navigate(['/login']);
        }
      },
        () => {
        });
    }

    finalSubmit() {
       
        console.log(this.api.isFormValid(this.form));
           if (this.api.isFormValid(this.form))
          {
            this.getStatus();
            const obj: any = {};
            obj.id = this.id;
            obj.password = this.form.controls.newPassword.value;
            this.api.postData(this.api.apiUrl.scoutChangePassword, obj)
                .subscribe(res => {
                if(res.statusCode == 200)
                {
                    this.api.passwordChanged();
                    setTimeout(() => {
                      this.router.navigate(['/login']);
                    }, 2000);
                    
                }
            },
        () => {
        });
          }
    }

}
